export const SERVICE_HOURS_TEST_ID = {
  root: 'service-hours',
  modal: 'service-hours-modal',
};
